import { Route } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { aiInsightsGuard } from './general/guards/ai-insights.guard';
import { boardExistsGuard } from './general/guards/board-exists.guard';
import { redirectToBoardGuard } from './general/guards/redirect-to-board.guard';
import { roleGuard } from './general/guards/role.guard';
import { boardNavigationResolver } from './general/shared/resolvers/board-navigation-resolver';

export const appRoutes: Route[] = [
	{
		path: 'ai-insights',
		loadComponent: () =>
			import('./menupoints/ai-insights/ai-insights.component').then((m) => m.AiInsightsComponent),
		canActivate: [MsalGuard, aiInsightsGuard],
		data: { reuse: true },
	},
	{
		path: 'dashboards',
		canActivateChild: [MsalGuard],
		resolve: {
			boardMenuItems: boardNavigationResolver,
		},
		children: [
			{
				path: 'dashboard/:id',
				loadChildren: () =>
					import('./menupoints/dashboard/dashboard.module').then((m) => m.DashboardModule),
				canActivate: [boardExistsGuard],
			},
			{
				path: 'statusboard/:id',
				loadComponent: () =>
					import('./menupoints/statusboard/statusboard.component').then(
						(m) => m.StatusboardComponent
					),
				canActivate: [boardExistsGuard],
			},
			{
				path: 'displaymode/:id',
				loadComponent: () =>
					import('./menupoints/boards/slideshow/boards-display-mode.component').then(
						(m) => m.BoardsDisplayModeComponent
					),
				canActivate: [boardExistsGuard],
			},
			{
				path: 'create',
				loadComponent: () =>
					import('./menupoints/boards/create/create-board.component').then(
						(m) => m.CreateBoardComponent
					),
			},
			{
				path: '',
				canActivate: [redirectToBoardGuard],
				children: [],
				pathMatch: 'full',
			},
		],
	},
	{
		path: 'processes',
		loadChildren: () =>
			import('apps/analytics/src/app/menupoints/processes/processes.routes').then(
				(m) => m.processesRoutes
			),
		canActivateChild: [MsalGuard, roleGuard],
	},
	{
		path: 'failures',
		loadChildren: () =>
			import('apps/analytics/src/app/menupoints/failures/failures.routes').then(
				(m) => m.failuresRoutes
			),
		canActivateChild: [MsalGuard, roleGuard],
	},
	{
		path: '**',
		redirectTo: 'ai-insights',
	},
];
